import React, { useEffect, useState } from "react";
import { hasPermission } from "../../../../utils/myFunctions";
import { useLocation, useNavigate } from "react-router";
import { decrypt } from "../../../../utils/Encrypt";
import useLogout from "../../../../utils/Utils";
import { useForm } from "react-hook-form";
import { getSubjectStudentListAPI } from "../../../../api/LMS/lmsdashboard";
import Head from "../../../../layout/head/Head";
import Content from "../../../../layout/content/Content";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, Icon } from "../../../../components/Component";
import ApiPaginationDataTable from "../../../../myComponents/DataTable/ApiPaginationDataTable";
import { Badge } from "reactstrap";
import { toast } from "react-toastify";

const SubjectSTudents = () => {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const enc = JSON.parse(localStorage.getItem("userDetail"));
  const user = decrypt(enc?.data || []);
  console.log("user", user);
  const isView = hasPermission(user, location?.pathname, "isView");
  const isUpdate = hasPermission(user, location?.pathname, "isUpdate");
  const isDelete = hasPermission(user, location?.pathname, "isDelete");
  const isCreate = hasPermission(user, location?.pathname, "isCreate");
  const logout = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: null,
      server_search: "",
    },
  });
  const [data, setData] = useState([]);
  //pagination
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(20);
  // pagination
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setPerPage(rows);
    setValue("page", page);
  };
  const handlePageChange = (page) => {
    setValue("page", page);
  };
   const [column, setColumn] = useState([
    {
      name: "Division",
      selector: (row) => row?.division_name,
      sortable: true,
      wrap:true
    },
    {
      name: "District",
      selector: (row) => row?.district_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Center Name",
      selector: (row) => row?.center_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Center Code",
      selector: (row) => row?.center_code,
      sortable: true,
      wrap: true,
    }, 
    {
      name: "Student Name",
      selector: (row) => row?.name,
      sortable: true,
    },
   {
      name: "Class",
      selector: (row) => row?.class_name,
      sortable: true,
      wrap: true,
    },
   
   

    {
         name: "Status",
         selector: (row) => row?.status,
         cell: (row) => (
           <div   >
             <Badge color={`${row.status=="approved"?  "success" : "danger"}`}>
               {row.status=="approved" ? "Enrolled" : ""}
             </Badge>
           </div>
         ),
         sortable: true,
         wrap: true,
       },
  
  ]);
  useEffect(() => {
    if (watch("server_search")?.length == 0) {
      handleSearch(perPage);
    }
  }, [watch("page"), perPage, watch("server_search")]);
  const handleSearch = (data) => {
    console.log("data", data);
    const payload = {
      limit: perPage,
      page: watch("page") || 1,
    };
    setIsLoading(true);
    getSubjectStudentListAPI(payload)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setTotalRows(res.data.data.totalRecords);
          setData(res.data.data.data);
          setIsLoading(false);
        } else if (status === false) {
          setData([]);
          setIsLoading(false);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Err", err);
      });
  };
  const serverSideSearch = (data) => {
    const body = {
      search: data,
    };
    // return;
    getSubjectStudentListAPI(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setIsLoading(false);
          setData(res.data.data.data);
        } else if (status === false) {
          setIsLoading(false);
          setData([]);
        } else if (status === "expired") {
          setIsLoading(false);
          logout();
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("catch error", err);
      });
  };
  return (
    <>
      <Head title={"Subject Students | LMS Dashboard"} />
      <Content>
        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Subject Students"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <div className="toggle-expand-content">
                  <ul className="nk-block-tools g-3">
                    <li className="nk-block-tools-opt">
                      <Button
                        size={"xs"}
                        color={`primary`}
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        <Icon className={`me-1`} name={`arrow-left`} />
                        {"Back"}
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>{" "}
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
             <ApiPaginationDataTable
            columns={column}
            data={data}
            isLoading={isLoading}
            register={register}
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            title={"Subject Students List"}
            errors={errors}
            serverSearch
            handleSubmit={handleSubmit}
            handleSearch={handleSearch}
            serverSideSearch={serverSideSearch}
            handlePerRowsChange={handlePerRowsChange}
            handlePageChange={handlePageChange}
            totalRows={totalRows}
            perPage={perPage}
          />
        </Block>
      </Content>
    </>
  );
};

export default SubjectSTudents;
